// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_GkRWM {
  font-family: "Inter", sans-serif;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #ffffff 21%, #f5f5f5 100%);

  .content_XM0S5 {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
    padding: 24px;
    gap: 100px;
    flex: 1 1;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;

    .leftContainer_i2kIl {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: 50%;
      padding-right: 20px;
      align-items: center;
    }
  }
}

.rightContainer_IbHIs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  max-width: 400px;
  padding: 20px 0;

  .mailIconContainer_mQICg {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }

  .emailDisplay_IgY_b {
    text-align: center;
    font-size: 14px;
    color: var(--_6-color);
    margin-bottom: 16px;
  }

  .resendContainer_tOdnd {
    text-align: center;
    font-size: 14px;
    color: var(--_6-color);
    margin-bottom: 24px;

    .resendButton_YoI2R {
      color: #162d3a;
      text-decoration: underline;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
      font: inherit;
    }
  }
}

.logoContainer_MUWWo {
  display: flex;
  padding: 54px 0px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  img {
    width: 100px;
  }

  p {
    font-size: clamp(30px, 12vw, 60px);
    color: var(--_2-color);
    margin: 0;
    text-transform: capitalize;
  }

  strong {
    font-weight: bolder;
    text-transform: uppercase;
  }

  @media (width<= 1150px) {
    img {
      width: 100px;
    }
    p {
      font-size: 65px;
    }
  }
}

#LogoGPT_vMHVx {
  width: 30%;
}

.title_As4gB {
  font-size: 32px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 16px;
}

.titleOtp_fwS02 {
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 16px;
  text-align: center;
}

.subtitle_gb0F2 {
  font-size: 18px;
  color: #313957;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 20px;
}

.subtitleOtp_Zfq_b {
  font-size: 18px;
  color: var(--_292d32-color);
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 20px;
  text-align: center;
}

.form_Xbtg4 {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.label_jqsen {
  font-size: 14px;
  font-weight: 500;
  color: #0c1421;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.input_jL38O {
  display: flex;
  width: 100%;

  padding: 15px;

  border: none;
  border-radius: 12px;
  font-size: 14px;
  color: #8897ad;
  border: none !important;
  outline: none !important;
  margin-bottom: 20px;
  background-color: var(--f4-background);
  height: 48px;
  box-sizing: border-box;
}

.passwordRequirements_b8yI0 {
  color: #8897ad;
  font-size: 9px;
  margin-top: -12px;
}

.forgotPasswordContainer_ct_0F {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.rememberMe_N4tzP {
  font-size: 12px;
  display: flex;
  gap: 8px;
  align-items: center;
}

.forgotPassword_c7wJP {
  font-size: 12px;
  color: #186654;
  text-align: right;
  font-weight: 400;
  text-decoration: none;
}

.signInButton_HZ_IC {
  width: 100%;
  background-color: var(--_2-color);
  color: var(--white-background);
  font-size: 18px;
  height: 48px;
  font-weight: 400;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: 18px;
  display: flex;
  height: 48px;
  align-self: center;
  align-items: center;
  justify-content: center;
}

.footerText_SUDhL {
  font-size: 16px;
  text-align: center;
  font-weight: 400;
  color: #313957;
  a {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }
}

.signUp_TqCUT {
  color: #11a380;
  text-decoration: none;
  font-weight: 500;
}

.footer_MadYU {
  font-size: 14px;
  text-align: center;
  color: #959cb6;
  font-weight: 400;
  margin-top: 20px;
}


.timer_rn0Mh {
  color: #162d3a;
  font-weight: 500;
  margin-left: 4px;
}

.securityNote_Nsf00 {
  text-align: center;
  font-size: 12px;
  color: var(--_6-color);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 32px;

  .lockIcon_K0tTG {
    font-size: 14px;
  }
}

.error_NT90h {
  color: #dc3545;
  font-size: 0.875rem;
  height: 21px;
  margin-top: 0.5rem;
  min-height: 21px;
  display: flex;
  align-items: center;
  gap: 5px;
  a{
    background-color: transparent;
    outline: none;
    border: none;
    color: #11a380;
    text-decoration: none;
    font-weight: 500;
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
  }
}

.loading_uHajc {
  opacity: 0.7;
  cursor: not-allowed;
}

.buttonGoogle_XZar4 {
  background-color: transparent;
  color: var(--black-color);
  font-size: 16px;
  font-weight: 400;
  border: 1px solid var(--d9-background);
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;
  height: 48px;
}

.forgotPasswordIcon_NL3Cw {
  color: #00d37f;
  width: 48px;
  height: 48px;
  margin-bottom: 24px;
  margin: 0 auto;
}

.forgotPasswordTitle_itIx5 {
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 16px;
  text-align: center;
}

.forgotPasswordSubtitle_fU8MQ {
  font-size: 16px;
  color: #666666;
  text-align: center;
  margin-bottom: 32px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}


.continueButton_bCIoZ {
  width: 100%;
  background-color: #162d3a;
  color: var(--white-background);
  font-size: 18px;
  height: 48px;
  font-weight: 400;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1524px) {
  .content_XM0S5 {
    gap: 120px;
  }
}

@media (max-width: 1248px) {
  .content_XM0S5 {
    gap: 80px;
  }
}

@media (max-width: 1024px) {
  .content_XM0S5 {
    flex-direction: column;
    align-items: center;
    gap: 50px;
    padding: 20px;
  }

  .leftContainer_i2kIl,
  .rightContainer_IbHIs {
    width: 100%;
    max-width: 388px;
    padding-right: 0;
  }

  .leftContainer_i2kIl {
    display: none;
  }

  .rightContainer_IbHIs {
    padding-top: 70px;
  }

  .forgotPasswordSubtitle_fU8MQ {
    max-width: 100%;
    padding: 0 20px;
  }
}

@media (max-width: 768px) {
  .title_As4gB {
    font-size: 22px;
  }

  .subtitle_gb0F2 {
    font-size: 16px;
  }
}

@media (max-width: 968px) {
  .leftContainer_i2kIl {
    display: none !important;
  }
}

@media (max-width: 480px) {
  .content_XM0S5 {
    padding: 16px;
    gap: 0px;
  }

  .forgotPasswordContainer_ct_0F {
    align-items: flex-start;
    gap: 10px;
  }
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}
.inputWrapper_DoxBN {
  display: flex;
  width: 100%;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  color: #8897ad;
  border: none !important;
  outline: none !important;
  margin-bottom: 20px;
  background-color: var(--f4-background);
  height: 48px;
  align-items: center;
  box-sizing: border-box;
  padding: 15px;
  .input_jL38O {
    margin-bottom: 0;
    padding: 0;
  }
}

.input_jL38O {
  flex: 1 1;
  padding-right: 40px; 
}

.icon_d3Qsl {
  right: 10px;
  cursor: pointer;
  opacity: 0;
}

.visible_Rwcum {
  opacity: 1;
}
.eye_xSHLn {
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/DashboardLogin/DashboardLogin.module.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8DAA8D;;EAE9D;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,SAAO;IACP,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;;IAEtB;MACE,SAAO;MACP,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,mBAAmB;MACnB,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,eAAe;;EAEf;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;;IAEnB;MACE,cAAc;MACd,0BAA0B;MAC1B,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,UAAU;MACV,aAAa;IACf;EACF;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT;IACE,YAAY;EACd;;EAEA;IACE,kCAAkC;IAClC,sBAAsB;IACtB,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE;MACE,YAAY;IACd;IACA;MACE,eAAe;IACjB;EACF;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;;EAEX,aAAa;;EAEb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd;IACE,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;;EAEhB;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.container {\n  font-family: \"Inter\", sans-serif;\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(180deg, #ffffff 21%, #f5f5f5 100%);\n\n  .content {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    justify-content: center;\n    padding: 24px;\n    gap: 100px;\n    flex: 1;\n    max-width: 1200px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n\n    .leftContainer {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      max-width: 50%;\n      padding-right: 20px;\n      align-items: center;\n    }\n  }\n}\n\n.rightContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 50%;\n  max-width: 400px;\n  padding: 20px 0;\n\n  .mailIconContainer {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 24px;\n  }\n\n  .emailDisplay {\n    text-align: center;\n    font-size: 14px;\n    color: var(--_6-color);\n    margin-bottom: 16px;\n  }\n\n  .resendContainer {\n    text-align: center;\n    font-size: 14px;\n    color: var(--_6-color);\n    margin-bottom: 24px;\n\n    .resendButton {\n      color: #162d3a;\n      text-decoration: underline;\n      background: none;\n      border: none;\n      cursor: pointer;\n      padding: 0;\n      font: inherit;\n    }\n  }\n}\n\n.logoContainer {\n  display: flex;\n  padding: 54px 0px;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  img {\n    width: 100px;\n  }\n\n  p {\n    font-size: clamp(30px, 12vw, 60px);\n    color: var(--_2-color);\n    margin: 0;\n    text-transform: capitalize;\n  }\n\n  strong {\n    font-weight: bolder;\n    text-transform: uppercase;\n  }\n\n  @media (width<= 1150px) {\n    img {\n      width: 100px;\n    }\n    p {\n      font-size: 65px;\n    }\n  }\n}\n\n#LogoGPT {\n  width: 30%;\n}\n\n.title {\n  font-size: 32px;\n  font-weight: 600;\n  color: #000000;\n  margin-bottom: 16px;\n}\n\n.titleOtp {\n  font-size: 20px;\n  font-weight: 600;\n  color: #000000;\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.subtitle {\n  font-size: 18px;\n  color: #313957;\n  font-weight: 400;\n  line-height: 1.5;\n  margin-bottom: 20px;\n}\n\n.subtitleOtp {\n  font-size: 18px;\n  color: var(--_292d32-color);\n  font-weight: 400;\n  line-height: 1.5;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #0c1421;\n  margin-bottom: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.input {\n  display: flex;\n  width: 100%;\n\n  padding: 15px;\n\n  border: none;\n  border-radius: 12px;\n  font-size: 14px;\n  color: #8897ad;\n  border: none !important;\n  outline: none !important;\n  margin-bottom: 20px;\n  background-color: var(--f4-background);\n  height: 48px;\n  box-sizing: border-box;\n}\n\n.passwordRequirements {\n  color: #8897ad;\n  font-size: 9px;\n  margin-top: -12px;\n}\n\n.forgotPasswordContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.rememberMe {\n  font-size: 12px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.forgotPassword {\n  font-size: 12px;\n  color: #186654;\n  text-align: right;\n  font-weight: 400;\n  text-decoration: none;\n}\n\n.signInButton {\n  width: 100%;\n  background-color: var(--_2-color);\n  color: var(--white-background);\n  font-size: 18px;\n  height: 48px;\n  font-weight: 400;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  margin-bottom: 18px;\n  display: flex;\n  height: 48px;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.footerText {\n  font-size: 16px;\n  text-align: center;\n  font-weight: 400;\n  color: #313957;\n  a {\n    cursor: pointer;\n    user-select: none;\n  }\n}\n\n.signUp {\n  color: #11a380;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.footer {\n  font-size: 14px;\n  text-align: center;\n  color: #959cb6;\n  font-weight: 400;\n  margin-top: 20px;\n}\n\n\n.timer {\n  color: #162d3a;\n  font-weight: 500;\n  margin-left: 4px;\n}\n\n.securityNote {\n  text-align: center;\n  font-size: 12px;\n  color: var(--_6-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 32px;\n\n  .lockIcon {\n    font-size: 14px;\n  }\n}\n\n.error {\n  color: #dc3545;\n  font-size: 0.875rem;\n  height: 21px;\n  margin-top: 0.5rem;\n  min-height: 21px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  a{\n    background-color: transparent;\n    outline: none;\n    border: none;\n    color: #11a380;\n    text-decoration: none;\n    font-weight: 500;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.loading {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.buttonGoogle {\n  background-color: transparent;\n  color: var(--black-color);\n  font-size: 16px;\n  font-weight: 400;\n  border: 1px solid var(--d9-background);\n  border-radius: 12px;\n  cursor: pointer;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: 8px;\n  height: 48px;\n}\n\n.forgotPasswordIcon {\n  color: #00d37f;\n  width: 48px;\n  height: 48px;\n  margin-bottom: 24px;\n  margin: 0 auto;\n}\n\n.forgotPasswordTitle {\n  font-size: 24px;\n  font-weight: 600;\n  color: #000000;\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.forgotPasswordSubtitle {\n  font-size: 16px;\n  color: #666666;\n  text-align: center;\n  margin-bottom: 32px;\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n\n.continueButton {\n  width: 100%;\n  background-color: #162d3a;\n  color: var(--white-background);\n  font-size: 18px;\n  height: 48px;\n  font-weight: 400;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  margin-bottom: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 1524px) {\n  .content {\n    gap: 120px;\n  }\n}\n\n@media (max-width: 1248px) {\n  .content {\n    gap: 80px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .content {\n    flex-direction: column;\n    align-items: center;\n    gap: 50px;\n    padding: 20px;\n  }\n\n  .leftContainer,\n  .rightContainer {\n    width: 100%;\n    max-width: 388px;\n    padding-right: 0;\n  }\n\n  .leftContainer {\n    display: none;\n  }\n\n  .rightContainer {\n    padding-top: 70px;\n  }\n\n  .forgotPasswordSubtitle {\n    max-width: 100%;\n    padding: 0 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .title {\n    font-size: 22px;\n  }\n\n  .subtitle {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 968px) {\n  .leftContainer {\n    display: none !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .content {\n    padding: 16px;\n    gap: 0px;\n  }\n\n  .forgotPasswordContainer {\n    align-items: flex-start;\n    gap: 10px;\n  }\n}\n\ninput[type=\"password\"]::-ms-reveal,\ninput[type=\"password\"]::-ms-clear {\n  display: none;\n}\n.inputWrapper {\n  display: flex;\n  width: 100%;\n  border: none;\n  border-radius: 12px;\n  font-size: 14px;\n  color: #8897ad;\n  border: none !important;\n  outline: none !important;\n  margin-bottom: 20px;\n  background-color: var(--f4-background);\n  height: 48px;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 15px;\n  .input {\n    margin-bottom: 0;\n    padding: 0;\n  }\n}\n\n.input {\n  flex: 1;\n  padding-right: 40px; \n}\n\n.icon {\n  right: 10px;\n  cursor: pointer;\n  opacity: 0;\n}\n\n.visible {\n  opacity: 1;\n}\n.eye {\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_GkRWM`,
	"content": `content_XM0S5`,
	"leftContainer": `leftContainer_i2kIl`,
	"rightContainer": `rightContainer_IbHIs`,
	"mailIconContainer": `mailIconContainer_mQICg`,
	"emailDisplay": `emailDisplay_IgY_b`,
	"resendContainer": `resendContainer_tOdnd`,
	"resendButton": `resendButton_YoI2R`,
	"logoContainer": `logoContainer_MUWWo`,
	"LogoGPT": `LogoGPT_vMHVx`,
	"title": `title_As4gB`,
	"titleOtp": `titleOtp_fwS02`,
	"subtitle": `subtitle_gb0F2`,
	"subtitleOtp": `subtitleOtp_Zfq_b`,
	"form": `form_Xbtg4`,
	"label": `label_jqsen`,
	"input": `input_jL38O`,
	"passwordRequirements": `passwordRequirements_b8yI0`,
	"forgotPasswordContainer": `forgotPasswordContainer_ct_0F`,
	"rememberMe": `rememberMe_N4tzP`,
	"forgotPassword": `forgotPassword_c7wJP`,
	"signInButton": `signInButton_HZ_IC`,
	"footerText": `footerText_SUDhL`,
	"signUp": `signUp_TqCUT`,
	"footer": `footer_MadYU`,
	"timer": `timer_rn0Mh`,
	"securityNote": `securityNote_Nsf00`,
	"lockIcon": `lockIcon_K0tTG`,
	"error": `error_NT90h`,
	"loading": `loading_uHajc`,
	"buttonGoogle": `buttonGoogle_XZar4`,
	"forgotPasswordIcon": `forgotPasswordIcon_NL3Cw`,
	"forgotPasswordTitle": `forgotPasswordTitle_itIx5`,
	"forgotPasswordSubtitle": `forgotPasswordSubtitle_fU8MQ`,
	"continueButton": `continueButton_bCIoZ`,
	"inputWrapper": `inputWrapper_DoxBN`,
	"icon": `icon_d3Qsl`,
	"visible": `visible_Rwcum`,
	"eye": `eye_xSHLn`
};
export default ___CSS_LOADER_EXPORT___;
